import { toBoolean } from "../../../shared/utils/booleanUtils";
import {
  BudgetTypeCode,
  ServiceRequest,
  ServiceRequestBase,
  ServiceRequestFile,
  ServiceRequestFormData,
  ServiceRequestStatusCode
} from "../models/models";

export const useServiceRequestConverters = () => {
  const toServiceRequestBase = (data: ServiceRequestFormData, files?: ServiceRequestFile[]): ServiceRequestBase => {
    const model: ServiceRequestBase = {
      issue: data.issue,
      description: data.description,
      affectedPartCategoryId: data.affectedPartCategoryId,
      openDate: data.openDate,
      serviceTypeCode: data.serviceTypeCode!,
      priorityTypeCode: data.priorityTypeCode!,
      flexibleDates: toBoolean(data.flexibleDates),
      worksiteAccessEnabled: data.worksiteAccessEnabled,
      budgetEnabled: data.budgetEnabled,
      paymentTermsEnabled: data.paymentTermsEnabled,
      notes: data.notes,
      alarmCode: data.alarmCode,
      locationId: data.locationId,
      files: files,
    };

    if (!model.flexibleDates) {
      model.serviceStartDate = data.serviceStartDate;
      model.serviceEndDate = data.serviceEndDate;
    }

    if (model.worksiteAccessEnabled) {
      model.workingHoursFrom = data.workingHoursFrom?.format("HH:mm:ss");
      model.workingHoursTo = data.workingHoursTo?.format("HH:mm:ss");
      model.weekendWorkPossible = data.weekendWorkPossible;
      model.afterHourAccessAvailable = data.afterHourAccessAvailable;
    }

    if (model.budgetEnabled) {
      const toDecimal = (val: any): number | undefined => {
        if (val === undefined || val === null || val === '') return undefined;
        const num = Number(val);
        return isNaN(num) ? undefined : num;
      };

      model.budgetTypeCode = data.budgetTypeCode ? Number(data.budgetTypeCode) : undefined;
      if (model.budgetTypeCode === BudgetTypeCode.fixed) {
        model.fixedBudget = toDecimal(data.fixedBudget);
      }
      if (model.budgetTypeCode === BudgetTypeCode.range) {
        model.budgetRangeFrom = toDecimal(data.budgetRangeFrom);
        model.budgetRangeTo = toDecimal(data.budgetRangeTo);
      }
    }

    if (model.paymentTermsEnabled) {
      model.paymentTermsCode = data.paymentTermsCode;
    }

    return model;
  };

  const toPreviewServiceRequest = (data: ServiceRequestFormData, files?: ServiceRequestFile[]): ServiceRequest => {
    const baseModel = toServiceRequestBase(data, files);
    const model: ServiceRequest = {
      ...baseModel,
      id: "",
      machine: { id: "", name: "" },
      internalNumber: "",
      statusCode: ServiceRequestStatusCode.draft,
      createdDate: new Date(),
      modifiedDate: new Date(),
    };

    return model;
  };

  return {
    toServiceRequestBase,
    toPreviewServiceRequest,
  };
};
